import { defineNuxtMiddleware } from '@nuxtjs/composition-api';

export default defineNuxtMiddleware(({ res }) => {
  if (process.server) {
    res.setHeader('X-Frame-Options', 'DENY');
  }
});
